﻿import { AdminStatusBadge } from "@/components/admin";
import { resolveAdminStatusDisplay } from "@/lib/adminCodeDisplay";
import { formatDateTime } from "@/lib/format";
import type { NotificationLogItem } from "@/types.ts";
interface NotificationLogCardProps {
    logs: NotificationLogItem[];
}
const isSent = (status: string) => {
    return status === "SENT" || status === "SUCCESS" || status === "COMPLETED";
};
const notificationTypeLabel = (notificationType: string) => {
    return resolveAdminStatusDisplay({
        group: "NOTIFICATION_TYPE",
        code: notificationType,
        fallbackTone: "blue",
    }).label;
};
const sendStatusDisplay = (sendStatus: string) => {
    return resolveAdminStatusDisplay({
        group: "NOTIFICATION_SEND_STATUS",
        code: sendStatus,
        fallbackTone: isSent(sendStatus) ? "emerald" : "orange",
    });
};
const NotificationLogCard = ({ logs }: NotificationLogCardProps) => {
    return (<div className="bg-white rounded-lg border border-slate-200 shadow-sm overflow-hidden">
      <div className="px-4 py-3 border-b border-slate-100 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-notification-3-line text-slate-500 text-sm"/>
          </div>
          <h3 className="text-sm font-semibold text-slate-700">알림 로그</h3>
        </div>
        <span className="text-xs text-slate-400">{logs.length}건</span>
      </div>
      <div className="divide-y divide-slate-50">
        {logs.length === 0 ? (<div className="px-4 py-6 text-center text-xs text-slate-500">선택한 이벤트의 알림 로그가 없습니다.</div>) : (logs.map((log) => (<div key={log.notificationLogId} className="px-4 py-2.5 flex items-center justify-between">
              <div className="flex flex-col gap-0.5 min-w-0 flex-1">
                <span className="text-xs font-medium text-slate-700 truncate">
                  {log.memberName ?? log.emergencyContactName ?? "수신자 미지정"}
                </span>
                <span className="text-xs text-slate-400">{notificationTypeLabel(log.notificationType)}</span>
              </div>
              <div className="flex flex-col gap-0.5 items-end ml-2">
                <AdminStatusBadge label={sendStatusDisplay(log.sendStatus).label} tone={sendStatusDisplay(log.sendStatus).tone} className="text-xs"/>
                <span className="text-xs text-slate-400 whitespace-nowrap">{formatDateTime(log.sentAt)}</span>
              </div>
            </div>)))}
      </div>
    </div>);
};
export default NotificationLogCard;

